/*
 * Migration Lot 5bis (2026-04-30) : `Others/Alert` est désormais un thin
 * wrapper sur la primitive shadcn `<Alert>` (variant=destructive). L'API
 * publique `{ message }` est préservée — les 11 callsites
 * (`<Alert message={error.message} />` dans les formulaires de validation)
 * n'ont pas besoin de changer.
 *
 * Pourquoi un wrapper et pas l'inlining direct dans chaque callsite : les
 * formulaires affichent une bannière d'erreur de validation **rouge**, pas
 * un toast. Le shape `{ message }` retourné par les sagas (`errors[].message`)
 * est figé côté Redux ; faire de l'inlining demanderait de changer 11
 * appelants pour `<Alert variant="destructive"><AlertDescription>...`.
 *
 * Le composant historique était 100% Tailwind (zéro MUI), mais utilisait
 * son propre SVG et palette `bg-red-50 text-red-500`. La primitive shadcn
 * utilise le token `--destructive` (cohérent avec le thème global) et
 * accepte une icône via convention `[&>svg]:absolute`.
 */
import * as React from "react";
import { AlertCircle } from "lucide-react";

import {
  Alert as ShadcnAlert,
  AlertDescription,
} from "@/components/ui/alert";

const Alert = ({ message }: { message: string }) => {
  return (
    // `md:max-w-2xl md:mx-auto` reproduit le centrage horizontal de
    // l'ancien composant — laisse les formulaires actuels intacts.
    <ShadcnAlert
      variant="destructive"
      className="md:max-w-2xl md:mx-auto bg-red-50"
    >
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>{message}</AlertDescription>
    </ShadcnAlert>
  );
};

export default Alert;
